<template>
  <div class="flex flex-col">
    <div class="flex justify-between bg-white p-6 header-vue">
      <h3 class="text-lg leading-6 font-medium text-gray-900 my-auto">
        <slot name="title"></slot>
      </h3>
      <div class="flex justify-between">
        <div class="flex justify-start items-center">
          <slot name="buttons"></slot>
        </div>
        <user-menu class="hidden md:flex"></user-menu>
      </div>
    </div>
  </div>
</template>
<script>
import UserMenu from "@/components/UserMenu";
import AlertNav from "@/components/AlertNav.vue";

export default {
  name: "Header",
  components: {
    AlertNav,
    UserMenu,
  },
   mounted() {
  },
};

//<!-- Google Tag Manager -->   <!-- BR#127 - Mbeng - Google Analytics - 19/09/2025 -->
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':

new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],

j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=

'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);

})(window,document,'script','dataLayer','GTM-WW5KQHZ');
//<!-- End Google Tag Manager -->
</script>



